// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Decco from "../../../../decco/lib/es6_global/src/Decco.bs.js";
import * as Js_dict from "../../../../rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../rescript/lib/es6/js_json.js";
import * as Js_array from "../../../../rescript/lib/es6/js_array.js";
import * as Belt_Array from "../../../../rescript/lib/es6/belt_Array.js";
import * as Pervasives from "../../../../rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../rescript/lib/es6/belt_Option.js";
import * as PageMeta$ApiTypes from "./PageMeta.bs.js";
import * as IdFunctor$ApiTypes from "./IdFunctor.bs.js";

function groupType_encode(v) {
  if (v) {
    return ["MutuallyExclusive"];
  } else {
    return ["Consistent"];
  }
}

function groupType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Consistent" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Consistent */0
                  };
          }
      case "MutuallyExclusive" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MutuallyExclusive */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var Id = IdFunctor$ApiTypes.Make({});

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(Id.t_encode, v.id)
              ],
              [
                "accountId",
                Decco.stringToJson(v.accountId)
              ],
              [
                "title",
                Decco.stringToJson(v.title)
              ],
              [
                "coverage",
                Decco.intToJson(v.coverage)
              ],
              [
                "variants",
                Decco.intToJson(v.variants)
              ],
              [
                "groupType",
                groupType_encode(v.groupType)
              ],
              [
                "trackingIds",
                Decco.arrayToJson(Decco.stringToJson, v.trackingIds)
              ],
              [
                "goalMetric",
                Decco.stringToJson(v.goalMetric)
              ],
              [
                "metrics",
                Decco.arrayToJson(Decco.stringToJson, v.metrics)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "updatedAt",
                Decco.floatToJson(v.updatedAt)
              ],
              [
                "deletedAt",
                Decco.optionToJson(Decco.floatToJson, v.deletedAt)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var accountId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "accountId"), null));
    if (accountId.TAG === /* Ok */0) {
      var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
      if (title.TAG === /* Ok */0) {
        var coverage = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "coverage"), null));
        if (coverage.TAG === /* Ok */0) {
          var variants = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "variants"), Decco.intFromJson), {
                TAG: /* Ok */0,
                _0: 2
              });
          if (variants.TAG === /* Ok */0) {
            var groupType = groupType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "groupType"), null));
            if (groupType.TAG === /* Ok */0) {
              var trackingIds = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "trackingIds"), (function (param) {
                          return Decco.arrayFromJson(Decco.stringFromJson, param);
                        })), {
                    TAG: /* Ok */0,
                    _0: []
                  });
              if (trackingIds.TAG === /* Ok */0) {
                var goalMetric = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "goalMetric"), Decco.stringFromJson), {
                      TAG: /* Ok */0,
                      _0: "transactions"
                    });
                if (goalMetric.TAG === /* Ok */0) {
                  var metrics = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "metrics"), (function (param) {
                              return Decco.arrayFromJson(Decco.stringFromJson, param);
                            })), {
                        TAG: /* Ok */0,
                        _0: [
                          "transactions",
                          "totalRevenue",
                          "bounceRate",
                          "averageSessionDuration",
                          "engagementRate",
                          "addToCarts",
                          "conversions",
                          "sessions",
                          "checkouts"
                        ]
                      });
                  if (metrics.TAG === /* Ok */0) {
                    var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
                    if (createdAt.TAG === /* Ok */0) {
                      var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
                      if (updatedAt.TAG === /* Ok */0) {
                        var deletedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "deletedAt"), null));
                        if (deletedAt.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    id: id._0,
                                    accountId: accountId._0,
                                    title: title._0,
                                    coverage: coverage._0,
                                    variants: variants._0,
                                    groupType: groupType._0,
                                    trackingIds: trackingIds._0,
                                    goalMetric: goalMetric._0,
                                    metrics: metrics._0,
                                    createdAt: createdAt._0,
                                    updatedAt: updatedAt._0,
                                    deletedAt: deletedAt._0
                                  }
                                };
                        }
                        var e = deletedAt._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".deletedAt" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = updatedAt._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".updatedAt" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = createdAt._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".createdAt" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = metrics._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".metrics" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = goalMetric._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".goalMetric" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = trackingIds._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".trackingIds" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = groupType._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".groupType" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = variants._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".variants" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = coverage._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".coverage" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = title._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".title" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = accountId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".accountId" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function groups_encode(v) {
  return Decco.arrayToJson(t_encode, v);
}

function groups_decode(v) {
  return Decco.arrayFromJson(t_decode, v);
}

var Group = {
  groupType_encode: groupType_encode,
  groupType_decode: groupType_decode,
  Id: Id,
  t_encode: t_encode,
  t_decode: t_decode,
  groups_encode: groups_encode,
  groups_decode: groups_decode
};

function productType_encode(v) {
  switch (v) {
    case /* Nav */0 :
        return ["Nav"];
    case /* Pages */1 :
        return ["Pages"];
    case /* Bio */2 :
        return ["Bio"];
    
  }
}

function productType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Bio" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Bio */2
                  };
          }
      case "Nav" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Nav */0
                  };
          }
      case "Pages" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Pages */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function experimentType_encode(v) {
  switch (v) {
    case /* AB */0 :
        return ["AB"];
    case /* Personalized */1 :
        return ["Personalized"];
    case /* Redirect */2 :
        return ["Redirect"];
    case /* AltFunnel */3 :
        return ["AltFunnel"];
    
  }
}

function experimentType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AB" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AB */0
                  };
          }
      case "AltFunnel" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AltFunnel */3
                  };
          }
      case "Personalized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Personalized */1
                  };
          }
      case "Redirect" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Redirect */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function ruleType_encode(v) {
  if (v) {
    return ["AudienceTargeting"];
  } else {
    return ["PageTargeting"];
  }
}

function ruleType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AudienceTargeting" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AudienceTargeting */1
                  };
          }
      case "PageTargeting" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PageTargeting */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function targetType_encode(v) {
  if (v) {
    return ["URL"];
  } else {
    return ["Config"];
  }
}

function targetType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Config" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Config */0
                  };
          }
      case "URL" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* URL */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function targetTypeDecoder(json) {
  var match = Decco.stringFromJson(json);
  if (match.TAG === /* Ok */0 && match._0 === "config") {
    return {
            TAG: /* Ok */0,
            _0: /* Config */0
          };
  } else {
    return targetType_decode(json);
  }
}

function experimentStatus_encode(v) {
  switch (v) {
    case /* Draft */0 :
        return ["Draft"];
    case /* Active */1 :
        return ["Active"];
    case /* Inactive */2 :
        return ["Inactive"];
    case /* Paused */3 :
        return ["Paused"];
    case /* Deleted */4 :
        return ["Deleted"];
    
  }
}

function experimentStatus_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Active" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Active */1
                  };
          }
      case "Deleted" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Deleted */4
                  };
          }
      case "Draft" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Draft */0
                  };
          }
      case "Inactive" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Inactive */2
                  };
          }
      case "Paused" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Paused */3
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "targetId",
                Decco.optionToJson(Decco.stringToJson, v.targetId)
              ],
              [
                "target",
                Decco.stringToJson(v.target)
              ],
              [
                "value",
                Decco.optionToJson(Decco.stringToJson, v.value)
              ],
              [
                "targetType",
                targetType_encode(v.targetType)
              ],
              [
                "splitRange",
                Decco.intToJson(v.splitRange)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "updatedAt",
                Decco.floatToJson(v.updatedAt)
              ],
              [
                "trackingId",
                Decco.optionToJson(Decco.stringToJson, v.trackingId)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetId"), null));
  if (targetId.TAG === /* Ok */0) {
    var target = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
    if (target.TAG === /* Ok */0) {
      var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
      if (value.TAG === /* Ok */0) {
        var targetType = targetTypeDecoder(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetType"), null));
        if (targetType.TAG === /* Ok */0) {
          var splitRange = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "splitRange"), null));
          if (splitRange.TAG === /* Ok */0) {
            var createdAt = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "createdAt"), Decco.floatFromJson), {
                  TAG: /* Ok */0,
                  _0: Date.now()
                });
            if (createdAt.TAG === /* Ok */0) {
              var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
              if (updatedAt.TAG === /* Ok */0) {
                var trackingId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trackingId"), null));
                if (trackingId.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            targetId: targetId._0,
                            target: target._0,
                            value: value._0,
                            targetType: targetType._0,
                            splitRange: splitRange._0,
                            createdAt: createdAt._0,
                            updatedAt: updatedAt._0,
                            trackingId: trackingId._0
                          }
                        };
                }
                var e = trackingId._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".trackingId" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = updatedAt._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".updatedAt" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = createdAt._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".createdAt" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = splitRange._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".splitRange" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = targetType._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".targetType" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = value._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".value" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = target._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".target" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = targetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

var Target = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function toString(operator) {
  switch (operator) {
    case /* Equal */0 :
        return "equal";
    case /* NotEqual */1 :
        return "notEqual";
    case /* GreaterThan */2 :
        return "greaterThan";
    case /* LessThan */3 :
        return "lessThan";
    case /* GreaterThanInclusive */4 :
        return "greaterThanInclusive";
    case /* LessThanInclusive */5 :
        return "lessThanInclusive";
    case /* In */6 :
        return "in";
    case /* NotIn */7 :
        return "notIn";
    case /* Contains */8 :
        return "contains";
    case /* DoesNotContain */9 :
        return "doesNotContain";
    
  }
}

function toOperator(operator) {
  switch (operator) {
    case "contains" :
        return /* Contains */8;
    case "doesNotContain" :
        return /* DoesNotContain */9;
    case "equal" :
        return /* Equal */0;
    case "greaterThan" :
        return /* GreaterThan */2;
    case "greaterThanInclusive" :
        return /* GreaterThanInclusive */4;
    case "in" :
        return /* In */6;
    case "lessThan" :
        return /* LessThan */3;
    case "lessThanInclusive" :
        return /* LessThanInclusive */5;
    case "notEqual" :
        return /* NotEqual */1;
    case "notIn" :
        return /* NotIn */7;
    default:
      return Pervasives.failwith("Invalid operator");
  }
}

function fact_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.optionToJson(Decco.stringToJson, v.name)
              ],
              [
                "fact",
                Decco.stringToJson(v.fact)
              ],
              [
                "operator",
                Decco.stringToJson(v.operator)
              ],
              [
                "value",
                v.value
              ],
              [
                "path",
                Decco.optionToJson(Decco.stringToJson, v.path)
              ]
            ]);
}

function fact_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var fact = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fact"), null));
    if (fact.TAG === /* Ok */0) {
      var operator = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "operator"), null));
      if (operator.TAG === /* Ok */0) {
        var value = {
          TAG: /* Ok */0,
          _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null)
        };
        if (value.TAG === /* Ok */0) {
          var path = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "path"), null));
          if (path.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      name: name._0,
                      fact: fact._0,
                      operator: operator._0,
                      value: value._0,
                      path: path._0
                    }
                  };
          }
          var e = path._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".path" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = value._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".value" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = operator._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".operator" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = fact._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fact" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function condition_encode(v) {
  return Js_dict.fromArray([
              [
                "all",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(fact_encode, param);
                      }), v.all)
              ],
              [
                "any",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(fact_encode, param);
                      }), v.any)
              ]
            ]);
}

function condition_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var all = Decco.optionFromJson((function (param) {
          return Decco.arrayFromJson(fact_decode, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "all"), null));
  if (all.TAG === /* Ok */0) {
    var any = Decco.optionFromJson((function (param) {
            return Decco.arrayFromJson(fact_decode, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "any"), null));
    if (any.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                all: all._0,
                any: any._0
              }
            };
    }
    var e = any._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".any" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = all._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".all" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function event_encode(v) {
  return Js_dict.fromArray([
              [
                "type_",
                Decco.stringToJson(v.type)
              ],
              [
                "result",
                Decco.boolToJson(v.result)
              ],
              [
                "params",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.params)
              ]
            ]);
}

function event_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
  if (type_.TAG === /* Ok */0) {
    var result = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
    if (result.TAG === /* Ok */0) {
      var params = Decco.optionFromJson((function (param) {
              return Decco.dictFromJson(Decco.stringFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "params"), null));
      if (params.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  type: type_._0,
                  result: result._0,
                  params: params._0
                }
              };
      }
      var e = params._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".params" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = result._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".result" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type_" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "conditions",
                condition_encode(v.conditions)
              ],
              [
                "event",
                event_encode(v.event)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var conditions = condition_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "conditions"), null));
  if (conditions.TAG === /* Ok */0) {
    var $$event = event_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "event"), null));
    if ($$event.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                conditions: conditions._0,
                event: $$event._0
              }
            };
    }
    var e = $$event._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".event" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = conditions._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".conditions" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Rule = {
  toString: toString,
  toOperator: toOperator,
  fact_encode: fact_encode,
  fact_decode: fact_decode,
  condition_encode: condition_encode,
  condition_decode: condition_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "groupId",
                Decco.optionToJson(Id.t_encode, v.groupId)
              ],
              [
                "title",
                Decco.stringToJson(v.title)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "accountId",
                Decco.stringToJson(v.accountId)
              ],
              [
                "product",
                productType_encode(v.product)
              ],
              [
                "targets",
                Decco.arrayToJson(t_encode$1, v.targets)
              ],
              [
                "pageTargetRule",
                t_encode$2(v.pageTargetRule)
              ],
              [
                "audienceTargetRule",
                t_encode$2(v.audienceTargetRule)
              ],
              [
                "rememberVisitor",
                Decco.boolToJson(v.rememberVisitor)
              ],
              [
                "status",
                experimentStatus_encode(v.status)
              ],
              [
                "experimentType",
                experimentType_encode(v.experimentType)
              ],
              [
                "coverage",
                Decco.optionToJson(Decco.intToJson, v.coverage)
              ],
              [
                "goalMetric",
                Decco.stringToJson(v.goalMetric)
              ],
              [
                "metrics",
                Decco.arrayToJson(Decco.stringToJson, v.metrics)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ],
              [
                "updatedAt",
                Decco.floatToJson(v.updatedAt)
              ],
              [
                "deletedAt",
                Decco.optionToJson(Decco.floatToJson, v.deletedAt)
              ],
              [
                "experimentStartAt",
                Decco.optionToJson(Decco.floatToJson, v.experimentStartAt)
              ],
              [
                "experimentEndAt",
                Decco.optionToJson(Decco.floatToJson, v.experimentEndAt)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var groupId = Decco.optionFromJson(Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "groupId"), null));
    if (groupId.TAG === /* Ok */0) {
      var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
      if (title.TAG === /* Ok */0) {
        var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
        if (description.TAG === /* Ok */0) {
          var url = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "url"), Decco.stringFromJson), {
                TAG: /* Ok */0,
                _0: ""
              });
          if (url.TAG === /* Ok */0) {
            var accountId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "accountId"), null));
            if (accountId.TAG === /* Ok */0) {
              var product = productType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product"), null));
              if (product.TAG === /* Ok */0) {
                var targets = Decco.arrayFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targets"), null));
                if (targets.TAG === /* Ok */0) {
                  var pageTargetRule = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pageTargetRule"), null));
                  if (pageTargetRule.TAG === /* Ok */0) {
                    var audienceTargetRule = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "audienceTargetRule"), null));
                    if (audienceTargetRule.TAG === /* Ok */0) {
                      var rememberVisitor = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "rememberVisitor"), Decco.boolFromJson), {
                            TAG: /* Ok */0,
                            _0: true
                          });
                      if (rememberVisitor.TAG === /* Ok */0) {
                        var status = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "status"), experimentStatus_decode), {
                              TAG: /* Ok */0,
                              _0: /* Draft */0
                            });
                        if (status.TAG === /* Ok */0) {
                          var experimentType = experimentType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "experimentType"), null));
                          if (experimentType.TAG === /* Ok */0) {
                            var coverage = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "coverage"), null));
                            if (coverage.TAG === /* Ok */0) {
                              var goalMetric = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "goalMetric"), Decco.stringFromJson), {
                                    TAG: /* Ok */0,
                                    _0: "transactions"
                                  });
                              if (goalMetric.TAG === /* Ok */0) {
                                var metrics = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "metrics"), (function (param) {
                                            return Decco.arrayFromJson(Decco.stringFromJson, param);
                                          })), {
                                      TAG: /* Ok */0,
                                      _0: [
                                        "transactions",
                                        "totalRevenue",
                                        "bounceRate",
                                        "averageSessionDuration",
                                        "engagementRate",
                                        "addToCarts",
                                        "conversions",
                                        "sessions",
                                        "checkouts"
                                      ]
                                    });
                                if (metrics.TAG === /* Ok */0) {
                                  var createdAt = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "createdAt"), Decco.floatFromJson), {
                                        TAG: /* Ok */0,
                                        _0: Date.now()
                                      });
                                  if (createdAt.TAG === /* Ok */0) {
                                    var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
                                    if (updatedAt.TAG === /* Ok */0) {
                                      var deletedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "deletedAt"), null));
                                      if (deletedAt.TAG === /* Ok */0) {
                                        var experimentStartAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "experimentStartAt"), null));
                                        if (experimentStartAt.TAG === /* Ok */0) {
                                          var experimentEndAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "experimentEndAt"), null));
                                          if (experimentEndAt.TAG === /* Ok */0) {
                                            return {
                                                    TAG: /* Ok */0,
                                                    _0: {
                                                      id: id._0,
                                                      groupId: groupId._0,
                                                      title: title._0,
                                                      description: description._0,
                                                      url: url._0,
                                                      accountId: accountId._0,
                                                      product: product._0,
                                                      targets: targets._0,
                                                      pageTargetRule: pageTargetRule._0,
                                                      audienceTargetRule: audienceTargetRule._0,
                                                      rememberVisitor: rememberVisitor._0,
                                                      status: status._0,
                                                      experimentType: experimentType._0,
                                                      coverage: coverage._0,
                                                      goalMetric: goalMetric._0,
                                                      metrics: metrics._0,
                                                      createdAt: createdAt._0,
                                                      updatedAt: updatedAt._0,
                                                      deletedAt: deletedAt._0,
                                                      experimentStartAt: experimentStartAt._0,
                                                      experimentEndAt: experimentEndAt._0
                                                    }
                                                  };
                                          }
                                          var e = experimentEndAt._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".experimentEndAt" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                  }
                                                };
                                        }
                                        var e$1 = experimentStartAt._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".experimentStartAt" + e$1.path,
                                                  message: e$1.message,
                                                  value: e$1.value
                                                }
                                              };
                                      }
                                      var e$2 = deletedAt._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".deletedAt" + e$2.path,
                                                message: e$2.message,
                                                value: e$2.value
                                              }
                                            };
                                    }
                                    var e$3 = updatedAt._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".updatedAt" + e$3.path,
                                              message: e$3.message,
                                              value: e$3.value
                                            }
                                          };
                                  }
                                  var e$4 = createdAt._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".createdAt" + e$4.path,
                                            message: e$4.message,
                                            value: e$4.value
                                          }
                                        };
                                }
                                var e$5 = metrics._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".metrics" + e$5.path,
                                          message: e$5.message,
                                          value: e$5.value
                                        }
                                      };
                              }
                              var e$6 = goalMetric._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".goalMetric" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                      }
                                    };
                            }
                            var e$7 = coverage._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".coverage" + e$7.path,
                                      message: e$7.message,
                                      value: e$7.value
                                    }
                                  };
                          }
                          var e$8 = experimentType._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".experimentType" + e$8.path,
                                    message: e$8.message,
                                    value: e$8.value
                                  }
                                };
                        }
                        var e$9 = status._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".status" + e$9.path,
                                  message: e$9.message,
                                  value: e$9.value
                                }
                              };
                      }
                      var e$10 = rememberVisitor._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".rememberVisitor" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                              }
                            };
                    }
                    var e$11 = audienceTargetRule._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".audienceTargetRule" + e$11.path,
                              message: e$11.message,
                              value: e$11.value
                            }
                          };
                  }
                  var e$12 = pageTargetRule._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".pageTargetRule" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                          }
                        };
                }
                var e$13 = targets._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".targets" + e$13.path,
                          message: e$13.message,
                          value: e$13.value
                        }
                      };
              }
              var e$14 = product._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".product" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                      }
                    };
            }
            var e$15 = accountId._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".accountId" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
          }
          var e$16 = url._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".url" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
        }
        var e$17 = description._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".description" + e$17.path,
                  message: e$17.message,
                  value: e$17.value
                }
              };
      }
      var e$18 = title._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".title" + e$18.path,
                message: e$18.message,
                value: e$18.value
              }
            };
    }
    var e$19 = groupId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".groupId" + e$19.path,
              message: e$19.message,
              value: e$19.value
            }
          };
  }
  var e$20 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$20.path,
            message: e$20.message,
            value: e$20.value
          }
        };
}

function experiments_encode(v) {
  return Decco.arrayToJson(t_encode$3, v);
}

function experiments_decode(v) {
  return Decco.arrayFromJson(t_decode$3, v);
}

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "page",
                Curry._1(PageMeta$ApiTypes.t_encode, v.page)
              ],
              [
                "experiments",
                Decco.arrayToJson(t_encode$3, v.experiments)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var page = Curry._1(PageMeta$ApiTypes.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
  if (page.TAG === /* Ok */0) {
    var experiments = Decco.arrayFromJson(t_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "experiments"), null));
    if (experiments.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                page: page._0,
                experiments: experiments._0
              }
            };
    }
    var e = experiments._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".experiments" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = page._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".page" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Page = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

var Experiment = {
  productType_encode: productType_encode,
  productType_decode: productType_decode,
  experimentType_encode: experimentType_encode,
  experimentType_decode: experimentType_decode,
  ruleType_encode: ruleType_encode,
  ruleType_decode: ruleType_decode,
  targetType_encode: targetType_encode,
  targetType_decode: targetType_decode,
  targetTypeDecoder: targetTypeDecoder,
  experimentStatus_encode: experimentStatus_encode,
  experimentStatus_decode: experimentStatus_decode,
  Target: Target,
  Rule: Rule,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  experiments_encode: experiments_encode,
  experiments_decode: experiments_decode,
  Page: Page
};

export {
  Group ,
  Experiment ,
}
/* Id Not a pure module */
